// extracted by mini-css-extract-plugin
export var actionText = "_lz-4";
export var container = "_lz-0";
export var leftSection = "_lz-1";
export var rightSection = "_lz-2";
export var settingsButton = "_lz-6";
export var settingsIcon = "_lz-7";
export var shortcut = "_lz-5";
export var shortcutGroup = "_lz-3";